//Auth Type

export const LOGIN_SET = "LOGIN_SET"
export const LOGIN_UNSET = "LOGIN_UNSET"